import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Link } from "react-router-dom";
import { Building2, Inbox, MailWarning } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ properties: 0, inquiries: 0, unread: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/properties?active_only=false"),
      api.get("/inquiries"),
    ])
      .then(([p, i]) => {
        const unread = i.data.filter((x) => x.status === "new").length;
        setStats({ properties: p.data.length, inquiries: i.data.length, unread });
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <p className="overline mb-2">Dashboard</p>
      <h1 className="font-serif-luxe text-5xl leading-none">
        Good to see you.
      </h1>
      <p className="mt-4 text-[#A3A3A3]">A quick look at your collection.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
        <StatCard
          icon={<Building2 size={18} />}
          label="Properties"
          value={stats.properties}
          to="/admin/properties"
          testid="stat-properties"
        />
        <StatCard
          icon={<Inbox size={18} />}
          label="Total inquiries"
          value={stats.inquiries}
          to="/admin/inquiries"
          testid="stat-inquiries"
        />
        <StatCard
          icon={<MailWarning size={18} />}
          label="Unread"
          value={stats.unread}
          to="/admin/inquiries"
          highlight
          testid="stat-unread"
        />
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        <ActionCard
          title="Add a property"
          desc="List a new home on the site — photos, amenities, price."
          to="/admin/properties/new"
          testid="action-add-property"
        />
        <ActionCard
          title="Review inquiries"
          desc="Reply to guests, mark as responded, keep the inbox tidy."
          to="/admin/inquiries"
          testid="action-view-inquiries"
        />
      </div>
    </div>
  );
}

function StatCard({ icon, label, value, to, highlight, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`block border p-6 transition-all hover:-translate-y-1 ${
        highlight
          ? "border-[#D4AF37]/50 bg-[#1C1C1E]"
          : "border-[#F5F5DC]/10 bg-[#1C1C1E]/60 hover:border-[#F5F5DC]/25"
      }`}
    >
      <div className="flex items-center gap-2 text-[#D4AF37]">{icon}</div>
      <p className="mt-4 font-serif-luxe text-5xl text-[#F5F5DC]">{value}</p>
      <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">
        {label}
      </p>
    </Link>
  );
}

function ActionCard({ title, desc, to, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="block border border-[#F5F5DC]/10 bg-[#1C1C1E]/60 hover:border-[#D4AF37]/40 p-8 transition-all group"
    >
      <h3 className="font-serif-luxe text-3xl group-hover:text-[#D4AF37] transition-colors">
        {title}
      </h3>
      <p className="mt-3 text-[#A3A3A3]">{desc}</p>
      <p className="mt-6 text-xs uppercase tracking-[0.2em] text-[#D4AF37]">
        Go →
      </p>
    </Link>
  );
}
